import React from 'react'
import { cpf as cpfValidator } from 'cpf-cnpj-validator'

const types = {
  cpf: {
    regex: /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}-?[0-9]{2}|[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}-?[0-9]{2})$/,
    message: 'Preencha um cpf válido',
    validator: cpfValidator.isValid
  },
  number: {
    regex: /^\d+$/,
    message: 'Utilize números apenas.',
    validator: null
  }
}

const useForm = (type, valueDefault) => {
  const [value, setValue] = React.useState(valueDefault)
  const [error, setError] = React.useState(null)

  function validate (value) {
    if (type === false) return true
    if (value.length === 0) {
      setError('Preencha um valor.')
      return false
    } else if (types[type] && !types[type].regex.test(value)) {
      setError(types[type].message)
      return false
    } else if (types[type] && types[type].validator != null && !types[type].validator(value)) {
      setError(types[type].message)
      return false
    } else {
      setError(null)
      return true
    }
  }

  function onChange ({ target }) {
    if (error) validate(target.value)
    setValue(target.value)
  }

  return {
    value,
    setValue,
    onChange,
    error,
    validate: () => validate(value),
    onBlur: () => validate(value)
  }
}

export default useForm
